module.exports = __webpack_public_path__ + "img/service1-updated.cf264e03.svg";